import { faHouse } from "@fortawesome/pro-solid-svg-icons";
import {
  FontAwesomeIcon,
  type FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

const HouseIcon = ({ ...props }: Omit<FontAwesomeIconProps, "icon">) => (
  <FontAwesomeIcon icon={faHouse} {...props} />
);

export { HouseIcon };
